module.exports = __webpack_public_path__ + "img/exmpl-ui_takeover-blocks.69bf529b.png";